module.exports = __webpack_public_path__ + "img/bg.f5f654ef.png";